import React from "react";

interface ThesisSectionProps {
  id?: string;
  label: React.ReactNode;
  heading: React.ReactNode;
  body: React.ReactNode;
}

const ThesisSection: React.FC<ThesisSectionProps> = ({ id, label, heading, body }) => {
  return (
    <section id={id} className="cs-section cs-thesis">
      <div className="cs-thesis-inner">
        <div className="cs-thesis-label">{label}</div>
        <div>
          <h2>{heading}</h2>
          {body}
        </div>
      </div>
    </section>
  );
};

export default ThesisSection;
